/**
 * AutodiagnosticoSeisAreas — Wrapper para el PsicoGadget "Autodiagnóstico
 * del equilibrio docente".
 *
 * El HTML del gadget vive como archivo estático en /public/autodiagnostico-seis-areas.html
 * (diseño, preguntas y lógica idénticos al original). Este wrapper lo embebe
 * dentro de la SPA con un iframe a pantalla completa para mantener:
 *   - La URL bonita /autodiagnostico-seis-areas
 *   - Acceso desde la sección PsicoGadgets
 *   - El chrome/nav de Chiessa Institute intacto
 *
 * FORM_ENDPOINT dentro del HTML apunta a /api/newsletter/psicogadget-signup
 * (endpoint interno, público, que guarda el correo en la misma base del boletín).
 */
import React, { useEffect } from "react";
import { useI18n } from "@/contexts/I18nContext";
import SiteNav from "@/components/site/SiteNav";
import SiteFooter from "@/components/site/SiteFooter";

export default function AutodiagnosticoSeisAreas() {
  const { lang } = useI18n();
  useEffect(() => {
    const prev = document.title;
    document.title = "Autodiagnóstico del equilibrio docente · Chiessa Institute";
    return () => { document.title = prev; };
  }, []);
  return (
    <div className="min-h-screen bg-paper flex flex-col" data-testid="autodiagnostico-page">
      <SiteNav />
      <main className="flex-1">
        <iframe
          src="/autodiagnostico-seis-areas.html"
          title={lang === "es" ? "Autodiagnóstico seis áreas" : "Six areas self-check"}
          className="w-full block"
          style={{ minHeight: "calc(100vh - 120px)", border: 0 }}
          data-testid="autodiagnostico-iframe"
        />
      </main>
      <SiteFooter />
    </div>
  );
}
